import type { RouteObject } from "react-router-dom"
import { useRoutes } from "react-router-dom"
import Layout from "@/components/Layout"
import Home from "@/pages/Home"
import About from "@/pages/About"
import Services from "@/pages/Services"
import DoulaService from "@/pages/DoulaService"
import ServicesMaman from "@/pages/ServicesMaman"
import ServicesFemme from "@/pages/ServicesFemme"
import ServicesBebe from "@/pages/ServicesBebe"
import FAQ from "@/pages/FAQ"
import CGV from "@/pages/CGV"
import GiftCard from "@/pages/GiftCard"
import PlanningAteliers from "@/pages/PlanningAteliers"
import Contact from "@/pages/Contact"

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "a-propos", element: <About /> },
      { path: "accompagnement-doula", element: <DoulaService /> },
      { path: "prestations-maman", element: <ServicesMaman /> },
      { path: "prestations-femme", element: <ServicesFemme /> },
      { path: "prestations-bebe", element: <ServicesBebe /> },
      { path: "accompagnements", element: <Services /> },
      { path: "faq", element: <FAQ /> },
      { path: "cgv", element: <CGV /> },
      { path: "planning-ateliers", element: <PlanningAteliers /> },
      { path: "carte-cadeau", element: <GiftCard /> },
      { path: "contact", element: <Contact /> },
    ],
  },
]

function App() {
  return useRoutes(routes)
}

export default App
